module.exports = __webpack_public_path__ + "www/1670826376000/img/examine_tip.8fa28c8.jpg";